/* eslint-disable no-debugger */
// import React from 'react'
// import ReactDom from 'react-dom'
// import Posts from '../components/Posts'

export default {
  init() {
    // JavaScript to be fired on the home page


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    // ReactDom.render(<Posts/>, document.getElementById('posts'));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js